Optional values that take precedence over the draft when updating.
